import React, { useState, useEffect } from 'react';
import './editform.css';
import api from '../../axiosInstance';
import { DataGrid } from '@mui/x-data-grid';
import { Button, IconButton } from '@mui/material';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import Swal from "sweetalert2";
import { ArrowBack, ArrowForward } from "@mui/icons-material";
import { useMediaQuery } from '@mui/material';
import AddCircleRoundedIcon from '@mui/icons-material/AddCircleRounded';
import SendIcon from "@mui/icons-material/Send"; // Import send mail icon
import ForwardToInboxOutlinedIcon from '@mui/icons-material/ForwardToInboxOutlined';
import { useNavigate } from "react-router-dom";
import { useParams } from "react-router-dom";
import { useSearchParams } from 'react-router-dom'
import axios from "axios"
import { baseURL } from '../../axiosInstance';




function Linkform() {
   const isMobile = useMediaQuery('(max-width:600px)');
   const [para] =useSearchParams()
   console.log("edtt para",para)
   const clientid = para.get('clientid')
   console.log("edit para parentid",clientid)
   const token = para.get('token')
   const parentid = para.get('parentid')
   const type = para.get("type")
 
   const disemail  = para.get('email')

    
  
    // const parent_id = sessionStorage.getItem('userid');
    
    const [formData, setFormData] = useState({
      parent_id:parentid,
      type: type,
      name: '',
      username:'',
      
      password: '',
      email: '',
      phone: '',
      address: '',
      language:'',
      country_id:'',
    });

    const [countryList, setCountryList] = useState()
    
   const fetchdata =  async()=> {

    try {
        const res= await axios.get(`${baseURL}/distributor/${clientid}`,{
            headers:{
                Authorization: `Bearer ${token}`,
                Accept:'application/json',
                identifier:disemail


            }
        })
        const resdata = res.data.data 
        console.log(" resdata", resdata)
        // setFormData((prev)=> ({
        //     ...prev,
        //     ...resdata
        // }))
        const filteredData = Object.keys(formData).reduce((acc, key) => {
          acc[key] = resdata[key] ?? ''; // Use nullish coalescing to prevent undefined values
          return acc;
        }, {});
    
        setFormData(filteredData);
        // setFormData(resdata)
       


    }
    catch(error){
        console.log("error",error)
    }

  }


  const fetchCountry = async() => {
    try{
    const res = await axios.get(`${baseURL}/listcountries`)
    setCountryList(res.data.data)
    }
    catch(error){
      console.log("error",error)
    }

  }

  useEffect(()=> {
  fetchdata()
  fetchCountry()


  },[])
  
  
    
    
    const handleChange = (e) => {
      const { name, value, type } = e.target;
      setFormData((prevData) => ({
        ...prevData,
        [name]: type === 'radio' ? Number(value) : value,
      }));
    };
    console.log("before client formdata",formData)


    const handleSubmit = async (e) => {
      e.preventDefault();
      const filteredData= Object.keys(formData).reduce((acc, key) => {
        if (formData[key] !== "" && formData[key] !== null && formData[key] !== undefined) {
          acc[key] = formData[key];
        }
        return acc;
      }, {});
      try {
        if(clientid){
          // const apiClient = axios.create({
          //   baseURL: baseURL,
          //   headers: {
          //     Authorization: `Bearer ${params.token}`,
          //     Accept: 'application/json',
          //     identifier: params.disemail
          //   }
          // });
          
          // const res = await apiClient.put(`/distributor/${clientid}`, { ...filteredData });
          const res = await axios.put(
            `${baseURL}/distributor/${clientid}`,
            { ...filteredData },
            {
              headers: {
                Authorization: `Bearer ${token}`,
                Accept: 'application/json',
                identifier: disemail
              }
            }
          );
    
          console.log("edit res",res)
            if (res.status === 200) {
                      // alert('Client added successfully!');
                      Swal.fire('Success!', 'Client updated successfully!', 'success');
            
                    }
          
    
          
        }
  
        // Reset form
        // setFormData({ parent_id:parentid, type: type, name: '', password: '', email: '', phone: '', address: '' });
      } catch (error) {
        // alert(`Error: ${error?.response?.data?.error}`);
        Swal.fire({
          icon: "error",
          title: "Error",
          text: error?.response?.data?.error || "Something went wrong!",
        });
        console.error(error);
      }
    };
  
  return (
    <div className='distributerbgimage rounded-3 shadow d-flex justify-content-center align-items-center vh-100 p-4'>
    <div className='p-4 shadow rounded-5  h-100 overflow-y-auto' style={{ width: "900px" ,maxHeight:"500px",overflow:"auto"}}>
      <form onSubmit={handleSubmit}>
        <div className='row' >
        {[
          { label: 'Name', name: 'name', type: 'text', required: true },
          {label:"Username", name:'username', type:"text", required:true},
          {label:"Lastname", name:'lastname', type:"text",required:true},

         
          ].map((field) => (
          <div key={field.name} className='col-md-6 col-12'>
            <label htmlFor={field.name} className='form-label distributerfont'>{field.label}</label>
            <input
              className='form-control'
              name={field.name}
              type={field.type}
              placeholder={field.label}
              value={formData[field.name]}
              onChange={handleChange}
              required={field.required}
            />
          </div>
        ))}
         {[
         

          {label:"0rganisation", name:"organisation", type:"text", required:true},
          { label: 'Email', name: 'email', type: 'email', required:true},
          { label: 'Phone Number', name: 'phone', type: 'text',required:true},
          ].map((field) => (
          <div key={field.name} className='col-md-6 col-12'>
            <label htmlFor={field.name} className='form-label distributerfont'>{field.label}</label>
            <input
              className='form-control'
              name={field.name}
              type={field.type}
              placeholder={field.label}
              value={formData[field.name]}
              onChange={handleChange}
              required={field.required}
            />
          </div>
        ))}

<div className='col-md-6 col-12'>
          <label htmlFor='address' className='form-label distributerfont'>Address</label>
          <textarea
            className='form-control'
            placeholder='Address'
            name='address'
            value={formData.address}
            onChange={handleChange}
          />
        </div>

        <div className='col-md-6 col-12'>
          <label htmlFor='language' className='form-label distributerfont'>Language</label>
          <select
            className='form-control'
            name='language'
            value={formData.language}
            onChange={handleChange}
            required
          >
            <option value="">Select Language</option>
            <option value="English">English</option>
            <option value="Arabic">Arabic</option>
            <option value="Malayalam">Malayalam</option>
          </select>
        </div>

       <div className='col-md-6 col-12'>
       <label htmlFor='country' className='form-label distributerfont' >Country</label>
          <select className='form-control'
          name='country_id'
          value={formData.country_id}
          onChange={handleChange}
          required
          >
          <option value=""></option>
          {
            countryList?.map((country)=> (
              <option value={country.id}>{country.name}</option>
            ))
          }

          </select>

       </div>
        
        </div>


        
       


        
       
       


        <div className='d-flex justify-content-center align-items-center py-2'>
          <Button variant="outlined" color="secondary" >Cancel</Button>
          <Button type='submit' variant="contained" color="primary" className='m-1'>
             Submit
          </Button>
        </div>
      </form>
    </div>
  </div>
  )
}

export default Linkform